<template>
	<div class="devlop">
		<div class="head">
			<div class="head-con"></div>
		</div>
		<div class="dev-mid">
			<div class="dev-mid-tit">
				<div>————</div>
				<div class="tit-text">智能软件定制开发</div>
				<div>————</div>
			</div>
			<div class="dev-mid-p">有完备的开发团队，超过10年的研发经验，可根据客户需求对系统随时快速的新增功能，修改需求，使软件产品最大限度的贴合当地的地方管理特色及地方管理要求。</div>
			<div class="dev-txtBox overflow">
				<div class="box1" v-for="(x, i) in arr1" :key="i + 'arr1'" :class="active == x?'active1':''" @click="handle(x,1)">{{x}}</div>
			</div>
			<div class="dev-mid-tit mt20">
				<div>————</div>
				<div class="tit-text">解决方案</div>
				<div>————</div>
			</div>
			<div class="dev-txtBox box2-wrap">
				<div class="box2" v-for="(x, i) in arr2" :key="i + 'arr2'" :class="active2 == x?'active2':''" @click="handle(x,2)">{{x}}</div>
			</div>
			<div class="dev-mid-tit mt20">
				<div>————</div>
				<div class="tit-text">案例客户</div>
				<div>————</div>
			</div>
			<swiper :options="option" ref="swiper">
				<swiper-slide v-for="x in arr3" :key="x.path"><a :href="x.path"><img :src="x.name"></a></swiper-slide>
			</swiper>
			<div style="display: none;">111</div>
		</div>
	</div>
</template>
<script>
	import Swiper from 'vue-awesome-swiper'
	import 'swiper/swiper-bundle.css'
	export default {
		data(){
			return{
				active: '专业架构',
				active2: '财务管理',
				arr1:['专业架构','云部署','硬件定制','安全保障','万向接口'],
				arr2:['财务管理','财政管理','系统集成','教务管理','供热管理','集团管理'],
				arr3:[
					{name:require('../../assets/images/login2.jpg'),path:'https://by.mizfnk.com'},
					{name:require('../../assets/images/login1.jpg'),path:'https://mizfnk.com'},
					{name:require('../../assets/images/login3.jpg'),path:'https://lx.mizfnk.com'}
				],
				option:{
					// clickable:true,
					loop:false,
					direction:'horizontal',
					// freeMode:true,
					slidesPerView:3,
					slidesPerView:'auto',
					centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
					spaceBetween: 30, // 在slide之间设置距离（单位px）。
					initialSlide:1,//默认第二张
					observer:true,
					observeParents:true,
					observeSlideChildren:true,
					
				}
			}
		},
		methods: {
			handle(val, num) {
				if (num == 1) {
					this.active = val;
				} else {
					this.active2 = val;
				}
			}
		}
	}
</script>
<style scoped>
	.touch .box1 {
		width: 2.2rem;
		float: left;
		font-size: 0.36rem;
		margin: 0.4rem 0.8rem;
		padding: 0.25rem 0;
	}
	.touch .box1:first-child {
		margin: 0 1rem 0 2.5rem;
	}
	.touch .box1:nth-child(2) {
		margin: 0 2rem 0 1.5rem;
	}
	.touch .box2 {
		height: 1.4rem;
		margin: 0.3rem 0;
		font-size: 0.36rem;
		float: left;
		width: 45%;
	}
	.touch .box2:nth-child(2n) {
		margin-left: 5%;
	}
	.touch .swiper-slide {
		padding-top: 0.3rem;
	}
	.touch .swiper-container{
		padding: 0.25rem 0;
	}
	.touch .devlop .head .head-con {
		background-image: url(../../assets/images/dingzhi_touch.png);
	}
	.pc .devlop .head .head-con {
		background-image: url(../../assets/images/dingzhi.png);
	}
	.pc .dev-mid-p{
		font-size: 22px;
		margin-bottom: 70px;
	}
	.pc .box1 {
		width: 160px;
		padding: 20px 0;
		font-size: 28px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.pc .box2{
		height: 120px;
		font-size: 28px;
		margin: 20px 0;
	}
	.pc .dev-txtBox{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.box1{
		border: 2px solid transparent;
		border-radius: 5px;
		cursor: pointer;
		background: rgba(255,255,255,.3);
		text-align: center;
	}
	.box1:hover, .devlop .active1{
		color: #FFEB3B;
		border-color: #FFEB3B;
		background-color: transparent;
	}
	.box2-wrap{
		flex-flow: wrap row;
	}
	.box2{
		display: flex;
		justify-content: center;
		align-items: center;
		background: #dddddd;
		flex: 0 0 26%;
		border-radius: 5px;
	}
	.box2:hover, .devlop .active2{
		background: #FFEB3B;
		cursor: pointer;
	}
	.pc .swiper-container{
		padding: 25px 0;
	}
	.pc .swiper-slide{
		padding-top: 30px;
	}
	.swiper-slide{
		width: 30%;
	}
	.pc .swiper-container .swiper-wrapper {
		margin-top: 30px;
		justify-content: space-between;
	}
	.swiper-slide img{
		max-width: 100%;
		display: block;
		margin: auto;
	}
	.swiper-slide-active{
		width: 40%;
		padding-top: 0 !important;
	}
	.pc .mt20 {
		margin: 80px auto 40px;
	}
</style>